import { SgmeHttp } from 'utils/sgmeHttp';
import { ajax } from 'rxjs/ajax';
import { sgwtConnect, getFakeUser } from 'api/connect';

export const sgmeHttp = SgmeHttp(
  sgwtConnect.getAuthorizationHeader.bind(sgwtConnect),
  ajax,
  getFakeUser(),
);
